<footer class="fluid-container bg-white">
    <div class="row footer-post-login" >
        <div class="col px-0">
			<div class="footer-container">
				<div class="links">
                    © {{ currentYear }} |
                    <a (click)="analyticsLinkData('privacy_policy')" i18n [href]="pathname ? '/'+locale+'/info/privacy-policy?referer='+ pathname : '/'+locale+'/info/privacy-policy'" target="_blank" rel="noreferrer noopener">Privacy Policy</a> |
                    <a (click)="analyticsLinkData('terms_conditions')" [href]="pathname ? '/'+locale+'/info/terms-and-conditions?referer='+ pathname : '/'+locale+'/info/terms-and-conditions'" target="_blank" rel="noreferrer noopener"><ng-container i18n>Terms </ng-container> <span i18n class="hide-mob">& Conditions</span></a> |
                    <a (click)="analyticsLinkData('customer_support')" i18n [href]="pathname ? '/'+locale+'/info/customer-support?referer='+ pathname : '/'+locale+'/info/customer-support'" target="_blank" rel="noreferrer noopener">Customer Support</a>
				</div>
				<div i18n class="best-viewed hide-on-mobile f300">
					Site best viewed in browsers Mozilla 3.5+, Chrome 3.0+, Safari 5.0+ on all desktops, laptops,
					and Android &amp; iOS mobile/tablet devices.
				</div>
	            <div class="powered-by flex align-items-center justify-content-center">
                        <!-- <span class="fnt-10 mar-right-5 mar-top-3 power-txt"  style="color: #B5B8B7;">POWERED BY</span> -->
                        <!-- <a href="https://poshvine.com/" target="_blank" rel="noreferrer noopener"><img class="pv-logo" src="assets/poshvine.png" alt="poshVine"></a> -->
                        <!-- <div class="separator mar-top-3"></div> -->
                        <img src="assets/pci-dss-compliant.png" alt="" class="mar-top-2 pci-logo">
              </div>

			</div>
		</div>
    </div>
</footer>
